"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useValidationSchema = exports.getColorFromStatus = void 0;
var _zod = require("zod");
var _components = require("./components");
var _types = require("./types");
const getColorFromStatus = status => {
  switch (status) {
    case _types.SubscriptionProcessStatus.Subscribed:
      return 'success';
    case _types.SubscriptionProcessStatus.Failed:
      return 'error';
    default:
      return 'info';
  }
};
exports.getColorFromStatus = getColorFromStatus;
const useValidationSchema = () => {
  const {
    content
  } = (0, _components.useNewsletterDialogContext)();
  const newsletterDialogValidationSchema = _zod.z.object({
    email: _zod.z.string().email(content.invalidEmailLabel)
  });
  return {
    newsletterDialogValidationSchema
  };
};
exports.useValidationSchema = useValidationSchema;